import React, { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

const GeoserverLayersOptions = [
  // { label: "AI Model 025-v1", value: "VALIDATION_PLAN:EU_025_historical_view" },
  { label: "AI Model 025", value: "VALIDATION_PLAN_v2:EU_025_historical_view" },
  // { label: "AI Model 025", value: "CNN_HISTORICAL:EU_025_live_demo" },
  // { label: "AI Model 0125-v1", value: "VALIDATION_PLAN:EU_0125_historical_view" },
  { label: "AI Model 0125", value: "VALIDATION_PLAN_v2:EU_0125_historical_view" }
];

const AutocompleteLayersGeoserver = ({ selectedModel, handleModelClick }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  // Actualizar el estado interno cuando cambie el selectedModel del padre
  useEffect(() => {
    const option = GeoserverLayersOptions.find(option => option.value === selectedModel);
    setSelectedOption(option || null);
  }, [selectedModel]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
      <Autocomplete
        options={GeoserverLayersOptions}
        getOptionLabel={(option) => option.label}
        value={selectedOption} // Sincronizamos el valor con el estado interno
        onChange={(event, newValue) => {
          if (newValue) {
            setSelectedOption(newValue); // Actualizamos el estado interno
            handleModelClick(newValue.value); // Notificamos al componente padre del cambio
          }
        }}
        disableClearable
        renderInput={(params) => (
          <TextField
            {...params}
            label="AI Model"
            variant="outlined"
            sx={{
              backgroundColor: '#f5f5f5', // Fondo claro y suave
              borderRadius: '8px', // Bordes redondeados
              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)', // Sombra para efecto de elevación
              '.MuiInputBase-input': {
                padding: '14px', // Más espacio interno para el texto
                color: '#333', // Color del texto principal
              },
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: '#1976d2', // Color del borde al seleccionar
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#115293', // Color del borde al pasar el ratón
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#1976d2', // Color del borde cuando está enfocado
              },
            }}
          />
        )}
        sx={{
          width: 170,
          marginTop: '10px',
          '.MuiAutocomplete-endAdornment': {
            '.MuiSvgIcon-root': {
              color: '#1976d2', // Color del icono de flecha desplegable
            },
          },
        }}
      />
    </Box>
  );
};

export default AutocompleteLayersGeoserver;
